import React from 'react';
import PropTypes from 'prop-types';

import Form from '../../../../components/Form';
import Input from '../../../../components/Input';
import ErrorLabel from '../components/ErrorLabel';
import basicInfoMessages from '../messages';
import '../styles.css';

export default function StudentRetention({ onChange, initialValue }) {
  return (
    <Form.Field styleName="field">
      <Input
        type="number"
        min={0}
        max={100}
        fluid
        name="studentRetention"
        maxLength="3"
        value={initialValue.value}
        onChange={(e, { value }) => {
          onChange(e, { value });
        }}
        error={initialValue.showError}
      />
      {initialValue.showError && <ErrorLabel error={{ ...basicInfoMessages.invalidError }} />}
    </Form.Field>
  );
}

StudentRetention.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};
